import { Link, useLocation, useNavigate } from "react-router-dom";
import { Home, User, PiggyBank, HandCoins, LogOut } from "lucide-react";
import { useAuth } from "../context/AuthContext";

const NAV = [
  { to: "/dashboard", label: "Beranda", icon: Home, testid: "nav-member-dashboard" },
  { to: "/profile", label: "Profil", icon: User, testid: "nav-member-profile" },
  { to: "/simpanan", label: "Simpanan", icon: PiggyBank, testid: "nav-member-simpanan" },
  { to: "/pinjaman", label: "Pinjaman", icon: HandCoins, testid: "nav-member-pinjaman" },
];

export default function MemberLayout({ children }) {
  const loc = useLocation();
  const nav = useNavigate();
  const { config, logout, user } = useAuth();

  return (
    <div className="min-h-screen bg-mint-pattern pb-20 lg:pb-0">
      <header className="sticky top-0 z-30 bg-brand text-white">
        <div className="max-w-3xl mx-auto px-5 py-4 flex items-center gap-3">
          {config?.logo ? (
            <img src={config.logo} alt="logo" className="w-10 h-10 rounded-xl object-cover ring-1 ring-white/20" />
          ) : (
            <div className="w-10 h-10 rounded-xl bg-gold flex items-center justify-center font-heading font-bold text-brand">K</div>
          )}
          <div className="flex-1 min-w-0">
            <div className="text-[11px] uppercase tracking-[0.22em] text-white/60">Anggota</div>
            <div className="font-heading font-bold truncate">{config?.name || "Kopsebra"}</div>
          </div>
          <button
            data-testid="member-logout-btn"
            onClick={async () => { await logout(); nav("/"); }}
            className="rounded-full bg-white/10 hover:bg-white/20 transition px-3 py-2 text-xs flex items-center gap-1.5"
          >
            <LogOut size={14} /> Keluar
          </button>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-5 py-6">{children}</main>

      {/* Bottom nav */}
      <nav className="fixed bottom-0 inset-x-0 z-40 bg-white/95 backdrop-blur-xl border-t border-brand/10 lg:hidden">
        <ul className="grid grid-cols-4 max-w-3xl mx-auto">
          {NAV.map((item) => {
            const Icon = item.icon;
            const active = loc.pathname === item.to;
            return (
              <li key={item.to}>
                <Link
                  to={item.to}
                  data-testid={item.testid}
                  className={
                    "flex flex-col items-center justify-center gap-1 py-2.5 text-[11px] " +
                    (active ? "text-brand font-semibold" : "text-brand-muted hover:text-brand")
                  }
                >
                  <span className={"w-9 h-9 rounded-xl flex items-center justify-center " + (active ? "bg-brand-soft" : "")}>
                    <Icon size={18} />
                  </span>
                  {item.label}
                </Link>
              </li>
            );
          })}
        </ul>
      </nav>

      {/* Desktop side rail */}
      <nav className="hidden lg:flex fixed top-1/2 right-6 -translate-y-1/2 flex-col gap-2 bg-white rounded-2xl shadow-lg p-2 border border-brand/10">
        {NAV.map((item) => {
          const Icon = item.icon;
          const active = loc.pathname === item.to;
          return (
            <Link
              key={item.to}
              to={item.to}
              data-testid={item.testid + "-desktop"}
              className={
                "flex items-center gap-2 px-3 py-2 rounded-xl text-sm " +
                (active ? "bg-brand text-white" : "text-brand-muted hover:bg-brand-soft")
              }
            >
              <Icon size={16} /> {item.label}
            </Link>
          );
        })}
      </nav>

      <div className="hidden">{user?.full_name}</div>
    </div>
  );
}
